export var SMALL_ICON_SIZE = '11px';
export var ICON_SIZE = '14px';
export var LARGE_ICON_SIZE = '20px';
export var SMALL_BUTTON_SIZE = '21px';
export var NORMAL_BUTTON_SIZE = '40px';